export default "__VITE_ASSET__CBQq67mQ__"